module.exports = __webpack_public_path__ + "img/2.6d99d6c6.jpg";